const routes = [
  {
    index: true,
    label: 'Gunnar Maples',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Technical Work',
    path: '/projects',
  },
  {
    label: 'Personal Projects',
    path: '/personal',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
